<template>
    <footer class="stdenis-footer">
        <div class="footer-top">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-6 footer-info">
                        <h3>ST.Denis</h3>
                        <p>
                            A Committed Family of God's Children, sharing and growing together each day in faith. We give thanks and praise to the Lord for a successful Diamond Jubilee Celebration. Do join us together as family in any of our scheduled Masses and grow in the Knowledge and Goodness of God and be enriched with His fullness of Blessings.                        </p>
                    </div>
                    <div class="col-lg-3 col-md-6 footer-links">
                        <h4>Useful links</h4>
                        <ul>
                            <li><i class="icon ion-md-arrow-dropright"></i> <router-link to="/">Home</router-link> </li>
                            <li><i class="icon ion-md-arrow-dropright"></i> <router-link to="/contact">Contact Us</router-link> </li>
                            <li><i class="icon ion-md-arrow-dropright"></i> <a href="#home">Societies</a> </li>
                            <li><i class="icon ion-md-arrow-dropright"></i> <a href="#home">Upcoming Program</a> </li>
                            <li><i class="icon ion-md-arrow-dropright"></i> <a href="#home">Announcements</a> </li>
                            <li><i class="icon ion-md-arrow-dropright"></i> <a target="_blank" href="https://admin.parishbulletin.org">Dashboard</a> </li>

                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 footer-links">
                        <h4>Contact Us</h4>
                        <p>
                            3/13, Thomas Drive,
                            <br>
                            Akoka, Bariga,
                            Lagos<br>
                            Nigeria<br>
                            <b>Phone:</b> +2348165214047<br>
                            <b>Email:</b> admin@stdenisakoka.org
                        </p>
                    </div>
                    <div class="col-lg-3 col-md-6 footer-links">
                        <h4>Our Mobile App</h4>
                        <p>
                            Get the latest information happening in the Parish on the ParishBulletin app.
                            Download the app today on Google Play store. Or Visit <a href="https://www.parishbulletin.org" target="_blank">www.parishbulletin.org</a>
                        </p>
                        <p>
                            <a href="https://play.google.com/store/apps/details?id=com.grandilo.parishbulletin" target="_blank">
                                <img src="../assets/images/logo/android.png" alt="parish bulletin app">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="stdenis-copy">
                &copy; Copyright <strong>St.Denis Catholic Church.</strong>
                All Rights Reserved
            </div>
            <div class="stdenis-credits">
                Powered by <b><a href="https://www.parishbulletin.org" style="color:#E12993">ParishBulletin</a></b>
            </div>
        </div>

    </footer>
</template>

<script>
    export default {
        name: "footerBar"
    }
</script>

<style scoped>
    .stdenis-footer{
        background: #3f83d4;
        padding: 0 0 30px 0;
        color: #ffffff;
        font-size: 14px;
    }
    .stdenis-footer .footer-top{
        background: #3578bc;
        padding: 60px 0 30px 0;
    }
    .stdenis-footer .footer-top h4:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        height: 2px;
        background: #E12993;
        width: 60px;
    }
    .stdenis-footer .footer-top .footer-info{
        margin-bottom: 30px;
    }
    .stdenis-footer .footer-top .footer-info h3{
        font-size: 34px;
        margin: 0 0 20px 0;
        padding: 2px 0 2px 10px;
        line-height: 1;
        font-weight: 700;
        letter-spacing: 3px;
        border-left: 4px solid #E12993;
        color: #ffffff;
        text-transform: uppercase;
    }
    .stdenis-footer .footer-top .footer-info p{
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 0;
        color: #ffffff;
    }
    .stdenis-footer .footer-top .footer-links{
        margin-bottom: 30px;
    }
    .stdenis-footer .footer-top .footer-links h4{
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        text-transform: uppercase;
        position: relative;
        padding-bottom: 12px;
    }
    .stdenis-footer .footer-top .footer-links ul{
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: left;
    }
    .stdenis-footer .footer-top .footer-links ul li{
        border-bottom: 1px solid rgba(255,255,255,0.5);
        padding: 10px 0;
    }
    .stdenis-footer .footer-top .footer-links ul li:first-child{
        padding-top: 0;
    }
    .stdenis-footer .footer-top .footer-links p{
        line-height: 26px;
    }
    .stdenis-footer .footer-top .footer-links p, .stdenis-footer .footer-top .footer-links b{
        color:#ffffff;
    }
    .stdenis-footer .footer-top .footer-links ul i{
        padding-right: 8px;
        color: #ffffff;
    }
    .stdenis-footer .footer-top .footer-links ul a{
        color: #ffffff;
        transition: all .3s linear;
    }
    .stdenis-footer .footer-top .footer-links ul a:hover{
        text-decoration: none;
        color: #E12993;
    }
    .stdenis-footer .stdenis-copy{
        text-align: center;
        padding-top: 30px;
        color: #ffffff;
    }
    .stdenis-footer .stdenis-copy strong{
        color: #ffffff;
    }
    .stdenis-footer .stdenis-credits{
        text-align: center;
        font-size: 13px;
        color: #ffffff;
    }

</style>